export type CanonicalAiAction =
  | 'CREATE'
  | 'UPDATE'
  | 'MOVE'
  | 'TOGGLE'
  | 'MAP'
  | 'REBALANCE'
  | 'DELETE'

const ACTION_PATTERNS: Array<[CanonicalAiAction, RegExp]> = [
  ['CREATE', /\b(create|make|add|build|generate|draft|extract)\b/i],
  ['UPDATE', /\b(update|change|edit|modify|set|rename)\b/i],
  ['MOVE', /\b(move|shift|reschedule|postpone|advance|delay)\b/i],
  ['TOGGLE', /\b(toggle|check|uncheck|complete|finish|reopen)\b/i],
  ['MAP', /\b(map|link|connect|depend|dependency|block|prerequisite)\b/i],
  ['REBALANCE', /\b(rebalance|redistribute|reorganize|restructure)\b/i],
  ['DELETE', /\b(delete|remove|archive|discard)\b/i],
]

export const extractCanonicalAiActions = (prompt: string): CanonicalAiAction[] =>
  ACTION_PATTERNS
    .filter(([, pattern]) => pattern.test(prompt))
    .map(([action]) => action)
